module.exports = __webpack_public_path__ + "img/img_level_20.bf5b0bcd.png";